import { reducer as storeReducer } from 'store/common';
import ActionType from './actionType';

const initialState = {
  accessKey: '',
  brokerId: null,
  brokerNaId: null,
  clientNaId: null,
  interactiveModeEnabled: false,
  password: null,
  passwordEnabled: false,
  readModeEnabled: true,
};

const setExternalAccessConfig = (state, payload) => {
  return {
    ...state,
    ...payload.externalAccessConfig,
  };
};

const actionsMapping = {
  [ActionType.SET_EXTERNAL_ACCESS_CONFIG]: setExternalAccessConfig,
};

const reducer = (state = initialState, action) => storeReducer(actionsMapping, state, action);

export default reducer;
